import { SeparatorProps } from "./types";
import { getSpacersClassNames } from "utilities/commonPropTypes/spacers";
import React from "react";
import classNames from "classnames/bind";

const Separator = ({
  customClass,
  marginBottom,
  marginTop,
  paddingBottom,
  paddingTop,
}: SeparatorProps) => {
  const stripClasses = classNames(
    customClass,
    getSpacersClassNames({
      marginBottom,
      marginTop,
      paddingBottom,
      paddingTop,
    }),
  );
  return <div className={stripClasses} />;
};

export default Separator;
